module.exports = __webpack_public_path__ + "static/img/yx-m-logo.36c35a99.png";